import { render } from "./ByType.vue?vue&type=template&id=2fc53cfc"
import script from "./ByType.vue?vue&type=script&lang=js"
export * from "./ByType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WebHost\\htdocs\\helpdesk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__